import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
var MatureStrictBlockedOverlay = function (props) {
    var t = useTranslation().t;
    var deviationType = getDeviationType(props.deviation);
    var isTier = deviationType === DeviationTypes.TIER;
    var matureTiers = useFlag('mature_tiers');
    return (React.createElement(HiddenLayout, __assign({ icon: React.createElement(Hidden, null), title: matureTiers && isTier && !props.compact
            ? t('deviationview.tier.blocked.mature.strict')
            : t('deviationview.blocked.mature.strict'), text: matureTiers && isTier
            ? null
            : t('deviationview.blocked.mature.strict.text'), strict: true }, props)));
};
MatureStrictBlockedOverlay.displayName = 'MatureStrictBlockedOverlay';
export default MatureStrictBlockedOverlay;
//# sourceMappingURL=MatureStrictBlocked.js.map